import { Component, OnInit } from '@angular/core';
import { BaseLoginComponent } from 'src/app/shared/components/base-login/base-login.component';

@Component({
  selector: 'app-sas-station-forgot-password',
  templateUrl: './sas-station-forgot-password.component.html',
  styleUrls: [
    '../style/global.css',
    './sas-station-forgot-password.component.css',
  ],
})
export class SasStationForgotPasswordComponent
  extends BaseLoginComponent
  implements OnInit {
  async init(): Promise<void> { }
}
